import { SEMANA_CAFE, formatCampaignDate, parseApiEventDate } from '../config/featuredEvents.js';

// One presentation for the carousel, agenda and search; unrelated IDs retain API data.
export function getEventPresentation(event = {}, currentYear = new Date().getFullYear()) {
  const id = String(event.eventId || /\/evento\/[^/]+\/(\d+)\/?(?:[?#].*)?$/.exec(event.eventUrl || '')?.[1] || '');
  const editorial = SEMANA_CAFE.events[id];
  return {
    name: editorial?.name || formatEventName(event.eventName || 'Evento sem nome'),
    venue: editorial?.venue || formatEventName((event.location || '').split(',')[0].trim()),
    date: editorial ? formatCampaignDate(editorial.schedule, currentYear) : formatEventDate(event.date, currentYear),
  };
}

// Preserve edited names; normalize the legacy all-caps labels.
export function formatEventName(value = '') {
  const text = String(value).trim();
  if (text !== text.toLocaleUpperCase('pt-BR')) return text;
  const smallWords = new Set(['de', 'da', 'do', 'das', 'dos', 'e', 'em', 'no', 'na']);
  return text.toLocaleLowerCase('pt-BR').replace(/[\p{L}\p{N}]+/gu, (word, offset) => {
    if (/^(dj|mc|al|pe|rn|sp|rj|ii|iii|iv|vi|vii|viii|ix)$/i.test(word)) return word.toUpperCase();
    if (offset > 0 && smallWords.has(word)) return word;
    return word[0].toLocaleUpperCase('pt-BR') + word.slice(1);
  });
}

export function formatEventDate(value, currentYear = new Date().getFullYear()) {
  const date = parseApiEventDate(value);
  if (!date) return value || 'Data a confirmar';
  const months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  const year = date.getFullYear() === currentYear ? '' : ` ${date.getFullYear()}`;
  const time = /(\d{1,2}):(\d{2})/.exec(value);
  const hour = time ? ` · ${Number(time[1])}h${time[2] === '00' ? '' : time[2]}` : '';
  return `${date.getDate()} ${months[date.getMonth()]}${year}${hour}`;
}
